/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 * 
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 * 
 * $Id: downloadsearchform.js
 */
$.namespace("SCS.downloadsearchresults");
SCS.downloadsearchresults.init = function(path) {
	$(document).on("downloadSearchEvent", function(event, selector) {
		selector = unescape(selector);
		var selector1 = encodeURIComponent(selector.replace('#', ''));
		if (SCS.downloadsearchform.isAjaxRequest == true) {
			   return;
		}
		$.ajax({
			beforeSend : function(jqXHR, settings) {
				SCS.downloadsearchform.isAjaxRequest = true;
				SCS.downloadsearchform.showAjaxLoader();
			},
			url : path + ".search" + selector1 + ".html",
			timeout : 50000,
			success : function(data) {
				$("#searchresult").html(data);
			},
			complete : function(jqXHR, textStatus) {
				SCS.downloadsearchform.hideAjaxLoader();
				SCS.downloadsearchform.isAjaxRequest = false;
			}
		});

	});
};

SCS.downloadsearchresults.openRequestedPopup = function(url) {
	var strWindowFeatures = "toolbar=no,menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=700,height=500,top=200";
	window.open(url, "", strWindowFeatures);
}

SCS.downloadsearchresults.loadDownloadButton = function(containerId, buttonUrl) {
	$.ajax({
		url : buttonUrl,
		timeout : 10000,
		success : function(data) {
			$(containerId).html(data);
			if ($(containerId + " a") != undefined) {
				$(containerId + " a").attr("baynote_dlcontext", "search");
			}
		},
		complete : function(jqXHR, textStatus) {

		}
	});
};

SCS.downloadsearchresults.clientSideValidation = false;

/**
 * Initialize Article search
 */
SCS.downloadsearchresults.initPagination = function(resultPerPage, numResults) {
	this.clientSideValidation = true;

	$(window).on('hashchange', function() {
		SCS.pagination
			.switchPage(location.hash, resultPerPage, numResults, ".helpteaser", "dlcPage-");
	});
	$(window).trigger('hashchange');
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/downloadsearchresults.js
// module id = 340
// module chunks = 0